import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"

import "./About.vue?vue&type=style&index=0&id=3c58824b&lang=css"
import "./About.vue?vue&type=style&index=1&id=3c58824b&lang=postcss&scoped=true"
import "./About.vue?vue&type=style&index=2&id=3c58824b&lang=postcss"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c58824b"]])

export default __exports__